<template>
  <div class="checkbox--common">
    <v-checkbox
      v-model="selectedValue"
      :label="label"
      class="checkbox--common-input"
      hide-details />
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    selectedValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang="scss">
@import '../../styles/vars/inputs';
@import '../../styles/vars/typography';

$_checkbox-border-compensator: 4px;

.checkbox--common {
  .v-input--selection-controls,
  .v-input--selection-controls__input {
    margin: 0;
    padding: 0;
  }

  .v-input__slot {
    align-items: flex-start;
  }

  .v-input--selection-controls__input {
    background: $checkbox-background;
    border-radius: 4px;
    height: $checkbox-size - $_checkbox-border-compensator;
    margin-right: $checkbox-size;
    width: $checkbox-size - $_checkbox-border-compensator;

    input {
      border-bottom-width: 0;
      border-top-width: 0;
    }
  }

  .v-input {
    .v-label {
      color: $typography-color-body;
      font-size: 1.15rem;
    }
  }

  .v-icon {
    display: none;
    font-size: $checkbox-size + $_checkbox-border-compensator;
    line-height: 1;
    margin: 0 - $_checkbox-border-compensator;
  }

  .v-input--is-label-active {
    .v-input--selection-controls__input {
      background: $checkbox-background-active;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
    }

    .v-icon {
      color: $checkbox-color-active !important;
      display: block;
    }
  }
}
</style>
